import { InternalPermission } from 'src/constants/internal-access/internalPermissions'
import { useHasPermission } from 'src/hooks/useHasPermission'
import { useKillswitchStatusKnown } from 'src/utils/hooks/paymentsOps/useKillswitchStatusKnown'
import { canRelyOnKillswitchStatus } from 'src/utils/paymentsOps/killswitchState'

/**
 * Whether refund Execute may be decided on the stored flag rows — see `canRelyOnKillswitchStatus`.
 * Captured-event replay and the Killswitch cards use `useKillswitchStatusKnown` instead.
 */
export const useCanRelyOnKillswitchStatus = (): boolean => {
  const canViewFlags = useHasPermission(InternalPermission.FeatureFlagsView)
  const isStatusKnown = useKillswitchStatusKnown()

  return canRelyOnKillswitchStatus(canViewFlags, isStatusKnown)
}
